import { useAuthService } from '~platform/auth';

import { Button } from '@breezeventures/ui-kit/button';
import { Icon } from '@breezeventures/ui-kit/next/icon';

export const LogoutButton = () => {
  const { logout } = useAuthService();

  return (
    <Button type="button" variant="secondary" size="s" onClick={logout}>
      <Button.Icon>
        <Icon name="bracket-right-arrow-left" size={24} version="v1" />
      </Button.Icon>
      Logout
    </Button>
  );
};
